import type { TermSummary } from "../buildTermSummary";

interface Props {
  summary: TermSummary;
}

function SummaryCard({
  title,
  value,
  unit,
  detail,
}: {
  title: string;
  value: number;
  unit: string;
  detail: string;
}) {
  return (
    <div className="rounded-xl border border-[var(--color-border-default)] bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.05)]">
      <p className="m-0 font-semibold text-[13px] text-[var(--color-text-secondary)]">
        {title}
      </p>
      <p className="mt-1 mb-0 font-bold text-2xl text-[var(--color-text-primary)]">
        {value}
        <span className="ml-0.5 font-medium text-base">{unit}</span>
      </p>
      <p className="mt-1 mb-0 text-[13px] text-[var(--color-text-secondary)]">
        {detail}
      </p>
    </div>
  );
}

/** ターム全体の進み具合。一覧を数えなくても、どこで止まっているかが分かるようにする */
export function TermSummaryCards({ summary }: Props) {
  return (
    <div className="mb-6 grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-4">
      <SummaryCard
        title="回答者"
        value={summary.respondentCount}
        unit="名"
        detail={`依頼送信済み ${summary.requestedCount}`}
      />
      <SummaryCard
        title="予約確定"
        value={summary.bookedCount}
        unit="名"
        detail={`未予約 ${summary.awaitingBookingCount}名`}
      />
      <SummaryCard
        title="実施済み"
        value={summary.completedCount}
        unit="件"
        detail={`予約確定 ${summary.bookedCount}名が実施待ち`}
      />
      <SummaryCard
        title="取り込み済みの回答"
        value={summary.importedAnswerCount}
        unit="件"
        detail={`回答者 × 受け取る人 ${summary.answerCount}件のうち`}
      />
    </div>
  );
}
